import { navigate } from "gatsby"
import React from "react"

import { FaBookOpen } from "../../../../AppReactIcons"
import lifestyle from "../../../../pages/ask/lifestyle"
import { DarkAppButton } from "../../../buttons"
import { iArticleData } from "../../../types"

const NextItem: React.FC<iArticleData> = props => {
  return (
    <div
      className="p-1"
      onClick={() => {
        props.source === "lifestyle"
          ? navigate(`/ask/lifestyle/articles/${props.slug}`)
          : navigate(`/articles/${props.slug}`)
      }}
    >
      <DarkAppButton title="Next" Icon={<FaBookOpen />} iconOnRight={true} />
    </div>
  )
}

export default NextItem
